document.addEventListener("DOMContentLoaded", function() {
  showToast();
});

document.addEventListener("turbolinks:load", function() {
  showToast();
});

function showToast() {
  $(".toast").addClass("show");

  setTimeout(function() {
    $(".toast").fadeOut('slow', function() {
      $(this).remove();
    });
  }, 5000);

  $(".toast-close").click(function() {
    $(this).parent().fadeOut('slow', function() {
      $(this).remove();
    });
  });
};
